import Heading from 'components/common/Heading';
import TempoAdSourceHeaderContent from 'components/signUpFunnel/Tempo/AdSourceHeaderContent';
import TempoAdSourceImageSection from 'components/signUpFunnel/Tempo/AdSourceImageSection';
import MyHealthyDishImageSection from 'components/signUpFunnel/Tempo/MyHealthyDishImageSection';
import SharapovaImageSection from 'components/signUpFunnel/Tempo/SharapovaImageSection';
import useQuery from 'hooks/useQuery';

const TempoHeader = () => {
  const { isQueryParamTrue: isAdSource } = useQuery('source', 'ad');
  const { isQueryParamTrue: isSharapova } = useQuery('ms', 'true');
  const { isQueryParamTrue: isMyHealthyDish } = useQuery('mhd', 'true');

  const ImageSection = () => {
    if (isSharapova) {
      return <SharapovaImageSection />;
    }
    if (isMyHealthyDish) {
      return <MyHealthyDishImageSection />;
    }

    return <TempoAdSourceImageSection />;
  };

  if (isAdSource) {
    return (
      <div className="relative">
        <TempoAdSourceHeaderContent isSharapova={isSharapova} isMyHealthyDish={isMyHealthyDish} />
        <ImageSection />
      </div>
    );
  }

  return (
    <Heading className="mx-auto mb-2 max-w-xl text-center">Let's get to know you a bit!</Heading>
  );
};

export default TempoHeader;
